/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Avatar,
  Card,
  Col,
  message,
  Row,
  Select,
  Space,
  Tag,
  Typography,
  List,
  Button,
  Tooltip,
} from "antd";
import { ExportOutlined, ImportOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { estadoConfig } from "../../utils/getEstadoProp";
import { getCardStyle } from "../../utils/getCardStyle";
import { formatFecha } from "../../utils/formatFecha";
import { getTipoTagProps } from "../../utils/getTipoTragProp";
import { useAuth } from "../../AuthContext";
import {
  getDataInStorage,
  saveDataInStorage,
} from "../../utils/manageLocalStorage";
import GETJaulasFiltradas from "../../helpers/jaula/GETJaulasFiltradas";
import GETListarDisponibles from "../../helpers/auditoria-sma/GETListarDisponibles";
import GETJaulaActual from "../../helpers/jaula/GETJaulaActual";
import POSTSeleccionarJaulaActual from "../../helpers/jaula/POSTSeleccionarJaulaActual";
import HeaderEstandar from "../../components/layout/headers/HeaderEstandar";
import AppLayout from "../../components/layout/AppLayout";
import Loader from "../../components/loader/Loader";
import GETArticuloPorSku from "../../helpers/articulos/GETArticulosPorSku";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import FiltroDropdown from "./filtro/FiltroDropdown";
// import GETZonasVenta from "../../helpers/auditoria-sma/GETZonasaVenta";
dayjs.extend(isSameOrBefore);
const { Text } = Typography;

const CardAuditoria = React.memo(function CardAuditoria({
  auditoriasma,
  darkMode,
  isExpanded,
  onToggle,
  onNavigate,
  filtroDropdownOpen,
}) {
  const estado = estadoConfig[auditoriasma.estado];
  const tipo =
    auditoriasma.afecta === 2
      ? { color: "green", text: "Ingreso", icon: <ImportOutlined /> }
      : auditoriasma.afecta === 1 || auditoriasma.afecta === 0
        ? { color: "volcano", text: "Egreso", icon: <ExportOutlined /> }
        : null;

  let detallesList = [];
  let parseError = false;
  if (isExpanded && auditoriasma.ctdsma > 1 && auditoriasma.detallesma) {
    try {
      const parsed = JSON.parse(auditoriasma.detallesma || "[]");
      if (Array.isArray(parsed)) {
        detallesList = parsed;
      } else {
        parseError = true;
      }
    } catch (e) {
      console.error("Error parsing detallesma:", e);
      parseError = true;
    }
  }

  return (
    <Col span={24} style={{ display: "flex" }}>
      <Card
        hoverable
        styles={{ body: { padding: 16 } }}
        onClick={() => {
          if (filtroDropdownOpen) return;
          onNavigate(auditoriasma);
        }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          opacity: filtroDropdownOpen ? 0.65 : 1,
          cursor: filtroDropdownOpen ? "default" : "pointer",
        }}
      >
        <Row align="middle" justify="space-between">
          <Space align="start">
            <Avatar
              src="/assets/audit-icon.png"
              size={60}
              style={{ backgroundColor: "#ffcc00" }}
            />
            <div>
              <Text
                strong
                style={{ fontSize: "22px", color: darkMode ? "#fff" : "#000" }}
              >
                {auditoriasma.numero}
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: "16px" }}>
                {formatFecha(auditoriasma.fecha)}
              </Text>
            </div>
          </Space>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              minWidth: 120,
              marginTop: 8,
            }}
          >
            <Tag
              color={estado?.color}
              icon={estado?.icon}
              style={{ fontSize: 17, width: 120, textAlign: "center" }}
            >
              {estado?.text}
            </Tag>
          </div>
        </Row>

        <Space
          direction="vertical"
          size="small"
          style={{ marginTop: 16, width: "100%" }}
        >
          {auditoriasma.sucursal && (
            <div>
              <Tag
                color={darkMode ? "geekblue" : "blue"}
                style={{ fontSize: "16px" }}
              >
                SUC
              </Tag>
              <Text
                style={{ color: darkMode ? "#ccc" : "#333", fontSize: "16px" }}
              >
                {auditoriasma.sucursal}
              </Text>
            </div>
          )}

          {auditoriasma?.numerosma && (
            <div>
              <Tag color="purple" style={{ fontSize: "16px" }}>
                WMS
              </Tag>
              <Text
                style={{ color: darkMode ? "#ccc" : "#333", fontSize: "16px" }}
              >
                {auditoriasma.numerosma}
              </Text>
            </div>
          )}

          {auditoriasma?.descri && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Tag color="purple" style={{ fontSize: "16px" }}>
                ERP
              </Tag>
              <Text
                style={{ color: darkMode ? "#ccc" : "#333", fontSize: "16px" }}
              >
                {auditoriasma.descri}
              </Text>
              {auditoriasma.ctdsma > 1 && (
                <Button
                  type="text"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle(e, auditoriasma.idauds);
                  }}
                  style={{
                    marginLeft: "auto",
                    minWidth: 30,
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 21,
                    flexShrink: 0,
                  }}
                >
                  {isExpanded ? "−" : "+"}
                </Button>
              )}
            </div>
          )}

          {isExpanded && auditoriasma.ctdsma > 1 && (
            <div
              style={{
                padding: 12,
                backgroundColor: darkMode ? "#2f2f2f" : "#f9f9f9",
                borderRadius: 8,
              }}
            >
              <Text
                strong
                style={{ fontSize: 15, color: darkMode ? "#fff" : "#000" }}
              >
                Detalle SMA ({auditoriasma.ctdsma}):
              </Text>

              {parseError ? (
                <Text
                  type="danger"
                  style={{ fontSize: 15, display: "block", marginTop: 8 }}
                >
                  Error al cargar los detalles
                </Text>
              ) : (
                <List
                  size="small"
                  dataSource={detallesList}
                  style={{ marginTop: 8, border: "none" }}
                  renderItem={(item, index) => (
                    <List.Item style={{ padding: "4px 0" }}>
                      <Tooltip title={item.descri} placement="top">
                        <Text
                          style={{
                            fontSize: 14,
                            padding: 8,
                            color: darkMode ? "#ccc" : "#555",
                            display: "block",
                            whiteSpace: "pre-line", // respeta saltos de línea
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "100%",
                          }}
                        >
                          {`${item.nrosma}\n${
                            item.descri.length > 70
                              ? `${item.descri.substring(0, 70)}…`
                              : item.descri
                          }`}
                        </Text>
                      </Tooltip>
                    </List.Item>
                  )}
                  locale={{ emptyText: "No hay detalles disponibles" }}
                />
              )}
            </div>
          )}

          <div style={{ display: "flex", alignItems: "center" }}>
            {tipo && (
              <Tag color={tipo.color} icon={tipo.icon} style={{ fontSize: 16 }}>
                {tipo.text}
              </Tag>
            )}

            {auditoriasma.smatip && (
              <Tag
                color={getTipoTagProps(auditoriasma.smatip).color}
                icon={getTipoTagProps(auditoriasma.smatip).icon}
                style={{ fontSize: "16px" }}
              >
                {auditoriasma.smatip}
              </Tag>
            )}
          </div>
        </Space>
      </Card>
    </Col>
  );
});

const AuditarSMA = ({ darkMode, setDarkMode }) => {
  const { loggedUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [jaulaActual, setJaulaActual] = useState(null);
  const [selectedJaula, setSelectedJaula] = useState(undefined);
  const [listadoAuditoriaSma, setListadoAuditoriaSma] = useState([]);
  const [expanded, setExpanded] = useState({});
  // ===== FILTROS =====
  const [jaulasFiltradas, setJaulasFiltradas] = useState(null);
  const [filtroDropdownOpen, setFiltroDropdownOpen] = useState(false);
  const [filtroConfirmado, setFiltroConfirmado] = useState(""); // se usa para filtrar
  const [filtroArticuloId, setFiltroArticuloId] = useState(null);
  const [filtroArticuloSku, setFiltroArticuloSku] = useState(null);
  const [filtroSucursales, setFiltroSucursales] = useState([]);
  const [filtroTipos, setFiltroTipos] = useState([]);
  const [filtroTransporte, setFiltroTransporte] = useState(undefined);
  const [filtroFecha, setFiltroFecha] = useState([]); // array de keys

  const closeDropdownTimeoutRef = useRef(null); // ← Agregar al inicio del componente

  // Función auxiliar para limpiar el timeout existente
  const clearCloseDropdownTimeout = () => {
    if (closeDropdownTimeoutRef.current) {
      clearTimeout(closeDropdownTimeoutRef.current);
      closeDropdownTimeoutRef.current = null;
    }
  };

  const valorTipeadoRef = useRef("");

  const loadFiltersForJaula = async (jaulaId) => {
    if (!jaulaId) {
      return {
        sucursales: [],
        tipos: [],
        transporte: null,
        fecha: [],
      };
    }
    const key = `auditarSma_filtro_${jaulaId}`;
    const saved = await getDataInStorage(key);

    return (
      saved || {
        sucursales: [],
        tipos: [],
        transporte: null,
        fecha: [],
      }
    );
  };

  useEffect(() => {
    if (jaulaActual?.id) {
      const key = `auditarSma_filtro_${jaulaActual.id}`;
      saveDataInStorage(key, {
        sucursales: filtroSucursales,
        tipos: filtroTipos,
        transporte: filtroTransporte,
        fecha: filtroFecha,
      });
    }
  }, [filtroSucursales, filtroTipos, jaulaActual?.id]);

  useEffect(() => {
    // Loading fetch para filtros de SMA
    const fetchData = async () => {
      setLoading(true);
      const [resJaulas, resAuditoria, resJaulaActual] = await Promise.all([
        GETJaulasFiltradas(loggedUser),
        GETListarDisponibles(),
        GETJaulaActual(),
      ]);

      let currentJaulaId = null;

      if (resJaulaActual.status === 200) {
        const jaula = resJaulaActual.data;
        setJaulaActual(jaula);
        setSelectedJaula(jaula?.id ?? undefined);
        currentJaulaId = jaula.id;
      }

      if (resJaulas.status === 200) setJaulasFiltradas(resJaulas.data);
      if (resAuditoria.status === 200) {
        // Primero en proceso, luego pausado y por ultimo pendientes
        const prioridadEstado = {
          2: 0,
          4: 1,
        };

        const ordenado = [...resAuditoria.data].sort((a, b) => {
          const pa = prioridadEstado[a.estado] ?? 2;
          const pb = prioridadEstado[b.estado] ?? 2;

          if (pa !== pb) return pa - pb;

          return new Date(b.fecha) - new Date(a.fecha);
        });

        setListadoAuditoriaSma(ordenado);
      }

      if (currentJaulaId) {
        const {
          sucursales = [],
          tipos = [],
          transporte = undefined,
          fecha = "ALL",
        } = await loadFiltersForJaula(currentJaulaId);

        // const dataZonasvta = await GETZonasVenta();
        // console.log(dataZonasvta);

        setFiltroSucursales(sucursales);
        setFiltroTipos(tipos);
        setFiltroTransporte(transporte);
        setFiltroFecha(fecha);
      } else {
        setFiltroSucursales([]);
        setFiltroTipos([]);
      }

      setLoading(false);
    };

    fetchData();
  }, [loggedUser]);

  const handleToggle = useCallback((e, id) => {
    e.stopPropagation();
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);

  const handleNavigate = useCallback(
    (auditoria) => {
      const basePath = `/auditar-sma/${auditoria.idauds}`;
      const searchParams = new URLSearchParams();

      if (jaulaActual?.nombre) {
        searchParams.set("jaula", jaulaActual.nombre);
      }

      // Agregamos un flag solo si es Recepción
      if (auditoria?.afecta === 2) {
        // if (auditoria?.smatip === "Recepcion de Mercadería") {
        searchParams.set("recep", "1"); // o "true", pero "1" es más corto
      }

      return navigate(`${basePath}?${searchParams.toString()}`);
    },
    [navigate, jaulaActual?.nombre],
  );

  const handleChangeJaula = useCallback(
    async (idJaula) => {
      const response = await POSTSeleccionarJaulaActual(idJaula);
      if (response?.status === 200) {
        setTimeout(() => {
          // message.success(response.data?.descri);
        }, 500);

        const [resJaula, resAuditoria] = await Promise.all([
          GETJaulaActual(),
          GETListarDisponibles(),
        ]);

        let newJaulaId = null;

        if (resJaula.status === 200) {
          const jaula = resJaula.data;
          setJaulaActual(jaula);
          setSelectedJaula(jaula?.id ?? undefined);
          newJaulaId = jaula.id;
        }

        if (resAuditoria.status === 200)
          setListadoAuditoriaSma(resAuditoria.data);

        if (newJaulaId) {
          const { sucursales = [], tipos = [] } =
            await loadFiltersForJaula(newJaulaId);
          setFiltroSucursales(sucursales);
          setFiltroTipos(tipos);
        } else {
          setFiltroSucursales([]);
          setFiltroTipos([]);
        }
      } else {
        message.error(response?.data?.descri || "Error al cambiar de jaula");
      }
    },
    [loggedUser],
  );

  const { sucursalesUnicas, tiposUnicos } = useMemo(() => {
    const suc = [
      ...new Set(listadoAuditoriaSma.map((i) => i.sucursal).filter(Boolean)),
    ];
    const tip = [
      ...new Set(listadoAuditoriaSma.map((i) => i.smatip).filter(Boolean)),
    ];
    return { sucursalesUnicas: suc, tiposUnicos: tip };
  }, [listadoAuditoriaSma]);

  // ===== TRANSPORTES ÚNICOS =====
  const transportesUnicos = useMemo(() => {
    const map = new Map();

    listadoAuditoriaSma.forEach((item) => {
      try {
        const detalles = JSON.parse(item.detallesma || "[]");
        detalles.forEach((d) => {
          if (d.idtran && d.transp && !map.has(d.idtran)) {
            map.set(d.idtran, { label: d.transp, value: d.idtran });
          }
        });
      } catch {}
    });

    return Array.from(map.values());
  }, [listadoAuditoriaSma]);

  // ===== FECHAS SMA (DINÁMICAS) =====
  const fechasClave = useMemo(() => {
    const hoy = dayjs().startOf("day");
    return {
      F0: hoy,
      F1: hoy.add(1, "day"),
      F2: hoy.add(2, "day"),
    };
  }, []); // ⚠️ Solo se calcula una vez al montar
  const opcionesFechaSma = useMemo(
    () => [
      { label: "Antes", value: "PAST" },
      { label: fechasClave.F0.format("DD/MM"), value: "F0" },
      { label: fechasClave.F1.format("DD/MM"), value: "F1" },
      { label: fechasClave.F2.format("DD/MM"), value: "F2" },
      { label: "Después", value: "FUTURE" },
    ],
    [fechasClave],
  );

  const listaFiltrada = useMemo(() => {
    return listadoAuditoriaSma.filter((item) => {
      const coincideSucursal =
        filtroSucursales.length === 0 ||
        filtroSucursales.includes(item.sucursal);

      const coincideTipo =
        filtroTipos.length === 0 || filtroTipos.includes(item.smatip);

      let coincideArticulo = true;
      if (filtroArticuloId) {
        try {
          const detalleArt = JSON.parse(item.detalleart || '{"articulos":[]}');
          const idsArticulos = detalleArt.articulos || [];
          coincideArticulo = idsArticulos.includes(filtroArticuloId);
        } catch {
          coincideArticulo = false;
        }
      }

      // ===== FILTRO TRANSPORTE =====
      let coincideTransporte = true;
      if (filtroTransporte !== undefined) {
        const detalles = JSON.parse(item.detallesma || "[]");
        if (filtroTransporte === null) {
          coincideTransporte = detalles.some((d) => !d.idtran);
        } else {
          coincideTransporte = detalles.some(
            (d) => d.idtran === filtroTransporte,
          );
        }
      }

      // ===== FILTRO FECHA SMA (fchent en detallesma) =====
      let coincideFecha = true;

      const { F0, F1, F2 } = fechasClave;

      const ventanasFecha = {
        PAST: (f) => f.isBefore(F0, "day"),
        F0: (f) => f.isSame(F0, "day"),
        F1: (f) => f.isSame(F1, "day"),
        F2: (f) => f.isSame(F2, "day"),
        FUTURE: (f) => f.isAfter(F2, "day"),
      };

      if (filtroFecha.length > 0) {
        try {
          const detalles = JSON.parse(item.detallesma || "[]");

          coincideFecha = detalles.some((d) => {
            if (!d.fchent) {
              return false;
            }

            const fecha = dayjs(d.fchent);
            const esValida = fecha.isValid();

            if (!esValida) return false;

            const matches = filtroFecha.some((key) => {
              const match = ventanasFecha[key]?.(fecha);
              return match;
            });

            return matches;
          });
        } catch (err) {
          coincideFecha = false;
        }
      }

      return (
        coincideSucursal &&
        coincideTipo &&
        coincideArticulo &&
        coincideTransporte &&
        coincideFecha
      );
    });
  }, [
    listadoAuditoriaSma,
    filtroSucursales,
    filtroTipos,
    filtroArticuloId,
    filtroTransporte,
    filtroFecha,
  ]);

  const handleTransporteCheck = (checkedValues) => {
    // checkedValues es un array con lo seleccionado
    const lastValue = checkedValues[checkedValues.length - 1];
    // Si estaba seleccionado y se desmarca → undefined (ninguno)
    // Si se selecciona uno nuevo → ese valor
    setFiltroTransporte((prev) => {
      if (prev === lastValue) return undefined; // Toggle off
      return lastValue; // Toggle on
    });
  };

  const limpiarFiltros = () => {
    setFiltroSucursales([]);
    setFiltroTipos([]);
    setFiltroArticuloId(null);
    setFiltroArticuloSku(null);
    setFiltroTransporte(undefined);
    setFiltroFecha([]);

    valorTipeadoRef.current = "";
  };

  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.closest(".ant-modal") ||
        e.ctrlKey ||
        e.altKey ||
        e.metaKey
      )
        return;

      // También ignorar si está en cualquier input/textarea
      if (
        document.activeElement?.tagName === "INPUT" ||
        document.activeElement?.tagName === "TEXTAREA" ||
        document.activeElement?.closest?.(".ant-select")
      ) {
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const codigo = valorTipeadoRef.current.trim();
        if (!codigo) return;

        const response = await GETArticuloPorSku(codigo);

        if (response.status === 200) {
          const idArticuloLogico =
            response.data?.articulo?.id ||
            response.data?.articuloFisico?.articuloLogico?.id;

          if (idArticuloLogico) {
            setFiltroArticuloId(idArticuloLogico);
            setFiltroArticuloSku(codigo);
          }
        }

        valorTipeadoRef.current = "";
      } else if (e.key === "Backspace") {
        valorTipeadoRef.current = valorTipeadoRef.current.slice(0, -1);
      } else if (e.key.length === 1 && /[a-zA-Z0-9]/.test(e.key)) {
        valorTipeadoRef.current += e.key;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const headerComponent = (
    <HeaderEstandar data={{ headerTitle: "Auditar SMA" }} />
  );

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <PullToRefresh
        onRefresh={async () => {
          setLoading(true);
          try {
            const [resJaulas, resAuditoria, resJaula] = await Promise.all([
              GETJaulasFiltradas(loggedUser),
              GETListarDisponibles(),
              GETJaulaActual(),
            ]);

            let currentJaulaId = null;
            if (resJaula.status === 200) {
              const jaula = resJaula.data;
              setJaulaActual(jaula);
              setSelectedJaula(jaula?.id ?? undefined);
              currentJaulaId = jaula.id;
            }
            if (resJaulas.status === 200) setJaulasFiltradas(resJaulas.data);
            if (resAuditoria.status === 200)
              setListadoAuditoriaSma(resAuditoria.data);

            if (currentJaulaId) {
              const { sucursales = [], tipos = [] } =
                await loadFiltersForJaula(currentJaulaId);
              setFiltroSucursales(sucursales);
              setFiltroTipos(tipos);
            } else {
              setFiltroSucursales([]);
              setFiltroTipos([]);
            }
          } finally {
            setLoading(false);
          }
        }}
        maxPullDownDistance={80}
        refreshingContent={null}
        pullingContent={null}
      >
        <div
          style={{
            height: "100%",
            padding: "8px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {loading && <Loader />}

          <div style={{ position: "relative", marginBottom: "16px" }}>
            <Space.Compact style={{ width: "100%" }}>
              <Select
                disabled={filtroDropdownOpen}
                placeholder="Seleccionar jaula"
                style={{ width: "calc(100% - 48px)", height: "60px" }}
                size="large"
                value={selectedJaula ?? undefined}
                tabIndex={-1} // No permite foco por teclado
                getPopupContainer={(trigger) => trigger.parentNode}
                //  onChange: limpiar timeout previo y aplicar blur inmediato
                onChange={(value) => {
                  handleChangeJaula(value);
                  clearCloseDropdownTimeout(); // Limpiar cualquier timeout pendiente
                  document.activeElement?.blur?.(); // Cerrar dropdown inmediatamente
                }}
                //  onClick: limpiar timeout previo antes de crear uno nuevo
                onClick={() => {
                  clearCloseDropdownTimeout();
                  closeDropdownTimeoutRef.current = setTimeout(() => {
                    document.activeElement?.blur?.();
                    closeDropdownTimeoutRef.current = null;
                  }, 2500);
                }}
                //  Opcional: limpiar timeout si el dropdown se cierra por otras razones
                onDropdownVisibleChange={(visible) => {
                  if (!visible) {
                    clearCloseDropdownTimeout();
                  }
                }}
                // onChange={(value) => {
                //   handleChangeJaula(value);
                //   // Quitar foco inmediatamente después de seleccionar
                //   setTimeout(() => {
                //     document.activeElement?.blur?.();
                //   }, 0);
                // }}
                // onClick={() => {
                //   // Quitar foco después del clic (permite abrir dropdown pero no retiene foco)
                //   setTimeout(() => {
                //     document.activeElement?.blur?.();
                //   }, 2500);
                // }}
              >
                {jaulaActual && (
                  <Select.Option key={jaulaActual.id} value={jaulaActual.id}>
                    {jaulaActual.nombre}
                  </Select.Option>
                )}
                {jaulasFiltradas
                  ?.filter((j) => j.id !== jaulaActual?.id)
                  .map((j) => (
                    <Select.Option key={j.id} value={j.id}>
                      {j.nombre}
                    </Select.Option>
                  ))}
              </Select>
              <FiltroDropdown
                filtroDropdownOpen={filtroDropdownOpen}
                setFiltroDropdownOpen={setFiltroDropdownOpen}
                filtroSucursales={filtroSucursales}
                setFiltroArticuloId={setFiltroArticuloId}
                setFiltroArticuloSku={setFiltroArticuloSku}
                limpiarFiltros={limpiarFiltros}
                sucursalesUnicas={sucursalesUnicas}
                setFiltroSucursales={setFiltroSucursales}
                tiposUnicos={tiposUnicos}
                filtroTipos={filtroTipos}
                setFiltroTipos={setFiltroTipos}
                filtroArticuloSku={filtroArticuloSku}
                opcionesFechaSma={opcionesFechaSma}
                filtroFecha={filtroFecha}
                setFiltroFecha={setFiltroFecha}
                filtroTransporte={filtroTransporte}
                handleTransporteCheck={handleTransporteCheck}
                transportesUnicos={transportesUnicos}
                darkMode={darkMode}
              />
            </Space.Compact>
          </div>

          {filtroConfirmado && (
            <div
              style={{
                padding: "8px",
                background: "#f0f0f0",
                marginBottom: "16px",
              }}
            >
              Filtrando por: <strong>{filtroConfirmado}</strong>
              <Button
                size="small"
                style={{ marginLeft: "8px" }}
                onClick={() => setFiltroConfirmado("")}
              >
                Limpiar
              </Button>
            </div>
          )}

          <Row gutter={[8, 8]} justify="start" align="stretch">
            {listaFiltrada.length === 0 && !loading ? (
              <Col span={24}>
                <Card
                  styles={{ body: { padding: 16 } }}
                  style={{
                    textAlign: "center",
                    backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "32px",
                  }}
                >
                  <Text type="secondary" style={{ fontSize: "19px" }}>
                    No hay órdenes disponibles.
                  </Text>
                </Card>
              </Col>
            ) : (
              listaFiltrada?.map((auditoriasma) => (
                <CardAuditoria
                  key={auditoriasma.idauds}
                  auditoriasma={auditoriasma}
                  darkMode={darkMode}
                  isExpanded={!!expanded[auditoriasma.idauds]}
                  onToggle={handleToggle}
                  onNavigate={handleNavigate}
                  filtroDropdownOpen={filtroDropdownOpen}
                />
              ))
            )}
          </Row>
        </div>
      </PullToRefresh>
    </AppLayout>
  );
};

export default AuditarSMA;
